"use client";
import t from "./index.es141.js";
import "react";
import "./index.es86.js";
t.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
//# sourceMappingURL=index.es85.js.map
